import React, { useEffect, useState } from "react";
import ShowAllStyles from "./ShowAll.styles";
import customTableStyles from "../../../../global/components/CustomTable/customTable.styles";
import {
  Box,
  Button,
  Grid,
  Popover,
  Typography,
  Stack,
  Dialog,
  DialogContent,
  TextField,
  DialogActions,
  Autocomplete,
  MenuItem,
  Chip,
  DialogTitle,
} from "@mui/material";
import {
  isTruthy,
  openErrorNotification,
  openSuccessNotification,
} from "../../../../helpers/methods";
import YhTable, { YhTableColumn, YhTableCellParams } from "../../../../ui/YhTable";
import YhInput from "../../../../ui/YhInput";

import CustomButton from "../../../../global/components/CustomButton/CustomButton";
import { ReactComponent as CloseIcon } from "../../../../assets/icons/close.svg";

import AddNewTeam from "../AddNewTeam/AddNewTeam";
import {
  changeUserPassword,
  getAllUnmappedProject,
  getAllUsers,
  getDateWiseTeam,
  handelExistingProjectAdd,
  handelNewProjectAdd,
  movingProject,
} from "./ShowAllService";
import notifiers from "../../../../global/constants/NotificationConstants";
import CustomLoader from "../../../../global/components/CustomLoader/CustomLoader";
import CustomDialog from "../../../../global/components/CustomModal/CustomModal";
import CustomRadioButton from "../../../../global/components/CustomRadioButton/CustomRadioButton";
import customErrorHandler from "../../../../utils/customErrorHandler";
import AddLoan from "../AddLoan/AddLoan";
import LoanList from "../AddLoan/RoleTabContent";

import { store } from "../../../../utils/store";
import history from "../../../../utils/history";
import urls from "../../../../global/constants/UrlConstants";
import { ReactComponent as VerticalDotIcon } from "../../../../assets/icons/verticalDot.svg";
import { DateRangePicker, LocalizationProvider } from "@mui/x-date-pickers-pro";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";

import { getTeamList } from "../../../MetaData/components/MetaList/components/AddTeamMetaList/CreateService";
import { applyLicenseKey } from "../../../../utils/License";
import { getProjectDetails } from "../../../Project/components/ShowAll/ShowAllService";
import {
  PORTAL_FILTERS,
  portalLabelFromRow,
  portalChipColor,
  filterPortalRows,
  mappingStatusLabel,
} from "../../aggregatorPortalUtils";
import { useSelector } from "react-redux";
import { selectActiveOrganizationId } from "../../../../redux/authSlice";

const SearchSvg = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="11" cy="11" r="8" />
    <path d="M21 21l-4.35-4.35" />
  </svg>
);

const ShowAll = (props: any) => {
  // LicenseInfo.setLicenseKey(
  //   "74c3b9c03880c75b0883807cc9f17463Tz05OTMwMCxFPTE3NTk1NTk4NjAwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLFBWPVEzLTIwMjQsS1Y9Mg=="
  // );
  useEffect(() => {
    applyLicenseKey();
  }, []);
  const classes = ShowAllStyles;
  const customTableClasses = customTableStyles;
  const privileges = store.getState().auth?.privileges || {};
  const activeOrganizationId = useSelector(selectActiveOrganizationId) || "";
  const [search, setSearch] = useState<string>("");
  const [userDataSource, setUserDataSource] = useState<any>([]);
  const [userDataSource1, setUserDataSource1] = useState<any>([]);
  const [existingProjectViewRows, setExistingProjectViewRows] = useState<string[]>([]);
  const [page, setPage] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(10);
  const [count, setCount] = useState<number>(5);
  const [addNewTeamDialog, setNewTeamDialog] = useState<any>({view:false,data:{}});
  const [getAddTeamMetaDataDylog, setGetAddTeamMetaDataDylog] =
    useState<boolean>(false);
  const [fixData, setFixData] = useState<any[]>([]);
  const [pageNumber, setPageNumber] = React.useState(0);
  const userPerPage = 10;
  const userCount = userDataSource.length;
  const pageVisited = pageNumber * userPerPage;
  const displayRows = userDataSource.slice(
    pageVisited,
    pageVisited + userPerPage
  );
  const [userId, setUserId] = useState("");
  const [status, setStatus] = useState("");
  const [apiResponse, setApiResponse] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedUser, setSelectedUser] = useState({ id: "", status: 0 });
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isDialogOpenLoan, setIsDialogOpenLoan] = useState<any>(false);
  const [isDialogOpenLoanList, setIsDialogOpenLoanList] = useState<any>(false);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [userRow_Id, setUserRow_Id] = useState<string>();
  const [rowStatus, setRowStatus] = useState();
  const [projectData, setProjectData] = useState<any[]>([]);
  const [projectSearch, setProjectSearch] = useState("");
  const [projectLoading, setProjectLoading] = useState(false);
  const [teamdata, setTeamData] = useState([]);
  const [passwordReset, setPasswordReset] = useState<any>(false);
  const [passwordResetId, setPasswordResetId] = useState("");
  const [password, setPassword] = useState("");
  const [existingProjectValue, setExistingProjectValue] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [idd, setIdd] = useState("");
 const [metaData, setMetaData] = useState<any>({});
    const [paginationModel, setPaginationModel] = React.useState({
      pageSize: 25,
      page: 0,
    });
    const [isSearchFocused, setIsSearchFocused] = useState(false);
  const [portalFilter, setPortalFilter] = useState<string>("all");
  const [moveConfirm, setMoveConfirm] = useState<{
    open: boolean;
    id: string;
    row: any | null;
  }>({ open: false, id: "", row: null });
  const [moveLoading, setMoveLoading] = useState(false);

      useEffect(() => {
        tableDataShowHandler();
      }, [search, paginationModel, portalFilter, activeOrganizationId]);

  const fetchExistingProjects = async (searchTerm = "") => {
    try {
      setProjectLoading(true);
      const response = await getProjectDetails({
        pageNumber: 0,
        pageSize: 50,
        search: searchTerm || "",
        status: "",
        propertyPurpose: "",
      });
      const rows = Array.isArray(response?.data) ? response.data : [];
      const unique: any[] = [];
      const seen = new Set<string>();
      rows.forEach((row: any) => {
        const projectId = row.projectId || row._id;
        const projectName = row.project_name;
        if (!projectId || !projectName || seen.has(String(projectId))) return;
        seen.add(String(projectId));
        unique.push({
          projectId,
          project_name: projectName,
          project_uid: row.project_uid,
        });
      });
      setProjectData(unique);
    } catch (error: any) {
      setProjectData([]);
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    } finally {
      setProjectLoading(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchExistingProjects(projectSearch);
    }, 300);
    return () => clearTimeout(timer);
  }, [projectSearch]);
    
  // useEffect(() => {
  //   tableDataShowHandler();
  // }, []);

  // get value from Input field
  interface typeOfTeamdataItem {
    team_name: any;
    _id: any;
  }
  const handleChange = (value: any) => {
    setPaginationModel({
      ...paginationModel,
      pageSize: value.target.value,
      page: 0,
    });
  };
  const onClickHandler = () => {
    setUserId("");
    setNewTeamDialog(true);
  };

  const handleEdit = (id: string) => {
    setNewTeamDialog(true);
    setUserId(id);
  };

  const handleLoan = (id: string, statusVal: any) => {
    setIsDialogOpenLoan(true);
    setUserId(id);
    setStatus(statusVal);
    setAnchorEl(null);
  };

  const handleCloseLoan = () => {
    setIsDialogOpenLoan(false);
    // tableDataShowHandler();
  };

  const handleLoanList = (id: string, statusVal: any) => {
    setIsDialogOpenLoan(false);
    setAnchorEl(null);
    setUserId(id);

    setIsDialogOpenLoanList(true);
    setStatus(statusVal);
  };

  const handleCloseLoanList = () => {
    setIsDialogOpenLoanList(false);
    // tableDataShowHandler();
  };



  const handelNewProject = async (row: any) => {
    try {
      const payload = {
        project_name: row.project_name,
        project_code: row.project_uid,
        _id: row._id,
      }
      const response = await handelNewProjectAdd(payload);

      customErrorHandler(response);
      openSuccessNotification(response?.message);
      setIsDialogOpen(false);
      tableDataShowHandler();
    } catch (error: any) {
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    }
  };
  const handleViewSalary = (user_id: string) => {
    history.push({
      pathname: urls.salarySlipViewPath,
      state: { fromPage: user_id }, //"64807274ee4348490a2181e1"
    });
  };
  const handleSetPassword = (user_id: string) => {
    setPasswordReset(true);
    setPasswordResetId(user_id);
  };
  const handleSetPasswordClose = () => {
    setPasswordReset(false);
  };
  const handlePopOver = (
    event: React.MouseEvent<HTMLButtonElement>,
    user_id: string,
    status: any
  ) => {
    setAnchorEl(event.currentTarget);
    setUserRow_Id(user_id);
    setRowStatus(status);
  };

  const handleClose = () => {
    setAnchorEl(null);
    // tableDataShowHandler();
  };
  const getTeamName = (id: any) => {
    const val: any = teamdata.filter(
      (item: typeOfTeamdataItem) => item._id === id
    );
    const ans = val?.length > 0 ? val[0]?.team_name : "";
    return <Typography sx={classes.rowtext}>{ans}</Typography>;
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const handleExistingProjectViewToggle = (rowId: string) => {
    setExistingProjectViewRows([rowId]);
    setExistingProjectValue("");
    setProjectSearch("");
  };
const handleAutocompleteChange = async(data:any,event:any,row:any)=>{
  try{
    if (!data) return;
    const projectId = data.projectId || data._id;
    if (!projectId) {
      openErrorNotification("Please select a valid project");
      return;
    }
    setExistingProjectValue(data.project_name)
              const payload  = {
                _id:row._id,
                project_id: projectId
              }
              const response = await handelExistingProjectAdd(payload);
              customErrorHandler(response);
              openSuccessNotification(response?.message);
              setExistingProjectViewRows([]);
              tableDataShowHandler();
              setExistingProjectValue("")
              setProjectSearch("")
  }catch{
    setExistingProjectValue("")
    setExistingProjectViewRows([]);
  }

}
const handelMovingProject = async (id: any) => {
  try {
    setMoveLoading(true);
    const response = await movingProject(id);
    customErrorHandler(response);
    openSuccessNotification(
      response?.message ||
        (response?.promoted
          ? `${response.promoted} lead(s) moved to All Leads`
          : "Move completed")
    );
    setExistingProjectViewRows([]);
    setMoveConfirm({ open: false, id: "", row: null });
    tableDataShowHandler();
    setExistingProjectValue("");
  } catch {
    setExistingProjectValue("");
    setExistingProjectViewRows([]);
  } finally {
    setMoveLoading(false);
  }
};

const openMoveConfirm = (row: any) => {
  setMoveConfirm({ open: true, id: row._id, row });
};
  const columns: YhTableColumn[] = [
    {
      headerName: 'Portal',
      field: 'portal',
      minWidth: 130,
      flex: 0.6,
      renderCell: (params: YhTableCellParams) => {
        const label = portalLabelFromRow(params.row);
        return (
          <Chip
            size="small"
            label={label}
            color={portalChipColor(label)}
            variant="outlined"
          />
        );
      },
    },
    {
      headerName: 'Project Name',
      field: 'project_name',
      minWidth: 350,
      flex: 1,
      renderCell: (params: YhTableCellParams) => (
        <Stack direction="column" justifyContent="flex-start" alignItems="flex-start" spacing={1}>
          <Typography  sx={classes.fullName}>{params.row?.project_name} </Typography>
        </Stack>
      ),
    },
    {
      headerName: 'Project Uid',
      field: 'project_uid',
      minWidth: 160,
      flex: 1,
      renderCell: (params: YhTableCellParams) => (
        <Stack direction="column" justifyContent="flex-start" alignItems="flex-start" spacing={1}>
          {params.row?.project_uid}
        </Stack>
      ),
    },
    {
      headerName: 'Status',
      field: 'status',
      minWidth: 140,
      flex: 0.7,
      renderCell: (params: YhTableCellParams) => (
        <Typography sx={{ fontSize: 12 }}>
          {mappingStatusLabel(params.row?.status)}
        </Typography>
      ),
    },
    {
      headerName: 'Action',
      field: 'action',
      minWidth: 420,
      flex: 1,
      renderCell: (params: YhTableCellParams) => {
        const isExistingProjectView = existingProjectViewRows.includes(params.row._id);
        console.log(params.row, "vvfvdfvdfvdfvdvdfvdfvdfv");
        return (
          <>
            {Number(params.row.status) === 0 && (
              <div style={{ display: 'flex', gap: '10px' }}>
                <Button
                  style={{ background: 'lightBlue' }}
                  onClick={() => handelNewProject(params.row)}
                >
                  New
                </Button>
                {!isExistingProjectView ? (
                  <Button
                    style={{ background: 'lightGrey' }}
                    onClick={() => handleExistingProjectViewToggle(params.row._id)}
                  >
                    Existing
                  </Button>
                ) : (
                  // <Autocomplete
                  //   disableClearable
                  //   onChange={(event: any, newValue: any | null) => {
                  //     handleAutocompleteChange(newValue || '', event, params.row);
                  //   }}
                  //   value={existingProjectValue}
                  //   style={{ width: "200px" }}
                  //   id="controllable-states-demo"
                  //   options={projectData}
                  //   renderInput={(params) => (
                  //     <TextField
                  //       {...params}
                  //       placeholder="select your project"
                  //     />
                  //   )}
                  //   renderOption={(props, option: any) => (
                  //     <li {...props} style={{ fontSize: '12px' }}>
                  //       {option.project_name}
                  //     </li>
                  //   )}
                  // />

                //   <Autocomplete
                //   disableClearable
                //   onChange={(event, newValue) => {
                //     handleAutocompleteChange(newValue || '', event, params.row);
                //   }}
                //   value={"hello"}
                //   style={{ width: "200px" }}
                //   id="controllable-states-demo"
                //   options={projectData}
                //   filterOptions={(options:any, { inputValue }) => 
                //     options.filter((option:any) => 
                //       option.project_name.toLowerCase().includes(inputValue.toLowerCase())
                //     )
                //   }
                //   getOptionLabel={(option:any) => option.project_name}
                //   renderInput={(params) => (
                //     <TextField
                //       {...params}
                //       placeholder="Select your project"
                //     />
                //   )}
                //   renderOption={(props, option:any) => (
                //     <li {...props} style={{ fontSize: '12px' }}>
                //       {option.project_name}
                //     </li>
                //   )}
                // />
                <Autocomplete
                loading={projectLoading}
                onOpen={() => {
                  if (!projectData.length) fetchExistingProjects(projectSearch);
                }}
                onChange={(event, newValue) => {
                  handleAutocompleteChange(newValue || '', event, params.row);
                }}
                inputValue={projectSearch}
                onInputChange={(_, value, reason) => {
                  if (reason === "input" || reason === "clear") {
                    setProjectSearch(value);
                  }
                }}
                value={
                  projectData.find((p: any) => p.project_name === existingProjectValue) ||
                  null
                }
                style={{ width: "240px" }}
                sx={customTableClasses.autocompleteStyle}
                id="existing-project-select"
                options={projectData || []}
                filterOptions={(options) => options}
                isOptionEqualToValue={(option, value) =>
                  option?.projectId === value?.projectId
                }
                getOptionLabel={(option: any) =>
                  typeof option === "string" ? option : option?.project_name || ""
                }
                noOptionsText={projectLoading ? "Loading..." : "No projects found"}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Search and select project"
                  />
                )}
                renderOption={(props, option) => (
                  <li {...props} key={option.projectId} style={{ fontSize: '12px' }}>
                    {option.project_name}
                  </li>
                )}
              />
              
                )}
              </div>
            )}
             {Number(params.row.status) === 1 && (
              <div style={{ display: 'flex', gap: '10px' }}>
                <Button
                  style={{ background: 'lightBlue' }}
                  onClick={() =>{setNewTeamDialog({view:true,data:params.row})}}
                >
                  Add Form
                </Button>
               
              </div>
            )}

             {Number(params.row.status) === 2 && (
              <div style={{ display: 'flex', gap: '10px' }}>
                <Button
                  style={{ background: 'lightBlue' }}
                  onClick={() => openMoveConfirm(params.row)}
                >
                  Move leads
                </Button>
               
              </div>
             )} 
          </>
        );
      }
      
    },
  ];

  const tableDataShowHandler = async () => {
    try {
      setApiResponse(true);
      const response3 = await getTeamList();
      const data3 = response3?.data;
      setTeamData(data3);
      const payload = {
        pageNumber: paginationModel.page,
        pageSize: paginationModel.pageSize,
        search:search || "",
        portal: portalFilter,
      }
      const response = await getAllUnmappedProject(payload);
      const rawRows = Array.isArray(response?.data) ? response.data : [];
      const rows = filterPortalRows(rawRows, portalFilter);
      setMetaData(
        response?.metadata?.[0]
          ? { ...response.metadata[0], total: response.metadata[0].total ?? rows.length }
          : { total: rows.length, page: paginationModel.page }
      );
      setLoading(true);
      const source = rows.map((userData: any) => {
        return {
          project_name: (
            <>
              <Typography sx={classes.fullName}>{userData?.project_name}</Typography>

            </>
          ),

          project_uid: (
            <>
              <Typography sx={classes.rowtext}>
                {userData?.project_uid}
              </Typography>
            </>
          ),
          action: (
            <></>
          )
        };
      });
      setUserDataSource([...source]);
      setUserDataSource1([...rows]);
      setFixData([...source]);
      setApiResponse(false);
    } catch (error: any) {
      setApiResponse(false);
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    }
  };

  const handleCloseAddTeam = () => {
    setNewTeamDialog({view:false,data:{}});
    tableDataShowHandler();
  };

  // Account status modal

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedUser({ ...selectedUser, status: +event.target.value });
  };

  const dialogHeaderContent = () => {
    return (
      <Box marginTop={1} marginRight={3} sx={{ cursor: "pointer" }}>
        <CloseIcon onClick={() => setIsDialogOpen(false)} />
      </Box>
    );
  };
 
  const updateDetails = async (type: any) => {
    try {
      if (passwordConfirm.length && passwordConfirm === password) {
        const response2 = await changeUserPassword({
          id: passwordResetId,
          password: password,
        });
        openSuccessNotification(response2.message);

        handleSetPasswordClose();
      } else {
        openErrorNotification("Value Not Matched");
      }
    } catch (error: any) {
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    }
  };
  const dialogTitleContent = () => {
    return (
      <>
        <Box sx={classes.content}>
          <Grid container>
            <Grid item xs={12}>
              <Typography sx={classes.pageHeading}>Account Status</Typography>
              <Typography sx={classes.pageSubHeading}>
                Change your account status
              </Typography>
            </Grid>
            {/* <DateRangePicker localeText={{ start: 'Check-in', end: 'Check-out' }} /> */}
            <Grid item xs={12} mt={5}>
              <Typography sx={classes.statusHeading}>Current Status</Typography>

              <Box sx={classes.checkBoxWarapper}>
                <CustomRadioButton
                  value={1}
                  checked={selectedUser.status == 1}
                  onChange={handleRadioChange}
                  label="Active"
                />

                <CustomRadioButton
                  value={0}
                  checked={selectedUser.status == 0}
                  onChange={handleRadioChange}
                  label="Deactive"
                />
              </Box>

              <Box>
                <CustomButton
                  onClick={() => {
                    // handleDeleteAccount();
                  }}
                  label="Delete Account"
                  buttonType="iconBtn"
                  customClasses={{ color: "red" }}
                />
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box sx={classes.buttonWrapperDialog}>
                <CustomButton
                  label="Save"
                  onClick={() => { }}
                  buttonType="primaryBtn"
                />
                <CustomButton
                  label="Cancel"
                  onClick={() => {
                    setIsDialogOpen(false);
                  }}
                  buttonType="secondaryBtn"
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
      </>
    );
  };
  const getShowAllPage = () => {
    return (
      <>
        <Box sx={classes.showAllWrapper}>
          <Grid container>
            <Grid item xs={12}>
              <Grid container columnSpacing={5}>
                <Grid item xs={12} mt={2} mb={4}>
                  <Box sx={classes.menuPart}>

                  </Box>
                </Grid>
              </Grid>
              <Grid container>
                                <Grid item xs={12} sx={customTableClasses.tableGridPart}>
                  <Box sx={{ mb: 2, display: "flex", flexWrap: "wrap", gap: 1 }}>
                    {PORTAL_FILTERS.map((p) => (
                      <Button
                        key={p.id}
                        size="small"
                        variant={portalFilter === p.id ? "contained" : "outlined"}
                        onClick={() => {
                          setPortalFilter(p.id);
                          setPaginationModel((prev) => ({ ...prev, page: 0 }));
                        }}
                      >
                        {p.label}
                      </Button>
                    ))}
                  </Box>
                  <Typography sx={{ mb: 1.5, fontSize: 13, color: "#6B7280" }}>
                    Portal projects that still need a CRM project or a lead form.
                    Once a lead form is in place they move to Existing Project.
                    UIDs: <code>MB_</code> Magic Bricks, <code>HC_</code> Housing,{" "}
                    <code>AC_</code> 99 Acres.
                  </Typography>
                  <Box sx={{ mb: 2, maxWidth: 420 }}>
                    <YhInput
                      placeholder="Search"
                      type="search"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                      autoFocus={isSearchFocused}
                      startAdornment={<SearchSvg />}
                      onFocus={() => setIsSearchFocused(true)}
                      onBlur={() => setIsSearchFocused(false)}
                    />
                  </Box>
                  {privileges &&
                    (privileges?.["Team List"]?.includes("view") ||
                      privileges?.["Team List"]?.includes("full control")) ? (
                    <>
                      <YhTable
                        key={`unmapped-${portalFilter}-${paginationModel.page}`}
                        columns={columns}
                        rows={userDataSource1 || []}
                        getRowId={(row) => row._id}
                        rowHeight={70}
                        loading={apiResponse}
                        emptyMessage="No unmapped projects found"
                        className="min-h-[320px]"
                        page={paginationModel.page}
                        pageSize={paginationModel.pageSize}
                        totalRows={metaData?.total || 0}
                        onPageChange={(p) =>
                          setPaginationModel((prev) => ({ ...prev, page: p }))
                        }
                        onPageSizeChange={(s) =>
                          setPaginationModel({ pageSize: s, page: 0 })
                        }
                      />
                      <Popover
                        id={id}
                        open={open}
                        anchorEl={anchorEl}
                        sx={{ top: "10px", left: "-20px" }}
                        onClose={handleClose}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "left",
                        }}
                      >
                        <Box sx={classes.innerPopOver}>
                          {privileges &&
                            (privileges?.["Team List"]?.includes("edit") ||
                              privileges?.["Team List"]?.includes(
                                "full control"
                              )) ? (
                            <>
                              <CustomButton
                                label="Edit"
                                buttonType="iconBtn"
                                onClick={() => {
                                  handleEdit(userRow_Id ?? "");
                                }}
                              />
                              <CustomButton
                                label="Add Loan"
                                buttonType="iconBtn"
                                onClick={() =>
                                  handleLoan(userRow_Id ?? "", rowStatus)
                                }
                              />

                              <CustomButton
                                label="View Loan"
                                buttonType="iconBtn"
                                onClick={() =>
                                  handleLoanList(userRow_Id ?? "", rowStatus)
                                }
                              />

                              <CustomButton
                                label="View Salary"
                                buttonType="iconBtn"
                                onClick={() =>
                                  handleViewSalary(userRow_Id ?? "")
                                }
                              />
                            </>
                          ) : (
                            ""
                          )}
                          <CustomButton
                            label="Reset Password"
                            buttonType="iconBtn"
                            onClick={() => handleSetPassword(userRow_Id ?? "")}
                          />
                        </Box>
                      </Popover>
                    </>
                  ) : (
                    ""
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          {addNewTeamDialog?.view && (
            <AddNewTeam
              isDialogOpen={true}
              handleCloseAddTeam={handleCloseAddTeam}
              userId={userId}
              idd={idd}
              setIdd={setIdd}
              newTeamDialogData = {addNewTeamDialog}
              editRowData={{}}
              tableDataShowHandler={tableDataShowHandler}
            />
          )}

          {apiResponse && <CustomLoader apiResponse={false} />}
        </Box>
        <CustomDialog
          fullScreen={true}
          isDialogOpen={isDialogOpen}
          dialogHeaderContent={dialogHeaderContent()}
          dialogTitleContent={dialogTitleContent()}
        />

        {isDialogOpenLoan && (
          <AddLoan
            isDialogOpenLoan={true}
            handleCloseLoan={handleCloseLoan}
            userId={userId}
            status={status}
          />
        )}

        {isDialogOpenLoanList && (
          <LoanList
            isDialogOpenLoan={true}
            handleCloseLoan={handleCloseLoanList}
            userId={userId}
            status={status}
          />
        )}
        <Dialog
          open={moveConfirm.open}
          onClose={() =>
            !moveLoading &&
            setMoveConfirm({ open: false, id: "", row: null })
          }
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>Move leads to All Leads?</DialogTitle>
          <DialogContent>
            <Typography sx={{ fontSize: 14, mb: 1 }}>
              This will move queued portal leads for{" "}
              <strong>{moveConfirm.row?.project_name}</strong> (
              <code>{moveConfirm.row?.project_uid}</code>) into{" "}
              <strong>All Leads</strong> in Pulse CRM.
            </Typography>
            <Typography sx={{ fontSize: 13, color: "#6B7280" }}>
              Only pending leads for this portal project are moved. They are
              assigned using the linked Lead Form and project assignees. Leads
              already moved are skipped.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() =>
                setMoveConfirm({ open: false, id: "", row: null })
              }
              disabled={moveLoading}
            >
              No
            </Button>
            <Button
              variant="contained"
              onClick={() => handelMovingProject(moveConfirm.id)}
              disabled={moveLoading}
            >
              {moveLoading ? "Moving…" : "Yes, move leads"}
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={passwordReset}
          onClose={handleSetPasswordClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              id="projectName"
              label="Create Password"
              value={password}
              type="Create Password"
              fullWidth
              variant="standard"
              onChange={(e: any) => {
                setPassword(e.target.value);
              }}
            />
          </DialogContent>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              id="projectName"
              label="Confirm Password"
              value={passwordConfirm}
              type="Confirm Password"
              fullWidth
              variant="standard"
              onChange={(e: any) => {
                setPasswordConfirm(e.target.value);
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleSetPasswordClose}>Cancel</Button>
            <Button
              onClick={() => {
                updateDetails("password");
              }}
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  };

  return getShowAllPage();
};

export default ShowAll;
